const request = require('request');
/* globals localStorage */

export default {
    login (email, pass, cb) {
      cb = arguments[arguments.length - 1]
      // if (localStorage.token) {
      //   if (cb) cb(true)
      //   this.onChange(true)
      //   return
      // }
      checkUser(email, pass, (res) => {
        if (res.authenticated) {
          localStorage.token = res.token
          localStorage.user = email
          localStorage.id = res.id
          if (cb) cb(true)
          this.onChange(true)
        } else {
          if (cb) cb(false)
          this.onChange(false)
        }
      })
    },
  
    getToken () {
      return localStorage.token
    },
  
    logout (cb) {
      delete localStorage.token
      delete localStorage.user
      delete localStorage.id
      if (cb) cb()
      this.onChange(false)
    },
  
    loggedIn () {
      console.log(localStorage.token)
        var obj = {  
          method: 'POST',
          headers: {
            'Authorization': "Basic " + window.btoa(process.env.VUE_APP_AUTH),
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Origin': 'localhost',
            'Host': 'localhost'
          },
          body: JSON.stringify({
            user: localStorage.user
          })
        }
        
        return fetch(process.env.VUE_APP_APIURL+'/auth/tokencheck', obj)
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData.token == localStorage.token && localStorage.token !== undefined) {
            console.log("Valid Token")
            return true;
          } else{
            console.log("Invalid Token")
            return false;
          }
        })
        .catch(error => console.log(error));
    },
  
    onChange () {}
  }

  
  function checkUser (email, pass, cb) {

      var obj = {  
        method: 'POST',
        headers: {
          'Authorization': "Basic " + window.btoa(process.env.VUE_APP_AUTH),
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Origin': 'localhost',
          'Host': 'localhost'
        },
        body: JSON.stringify({
          'email': email,
          'pass': pass,
        })
      }
      
      fetch(process.env.VUE_APP_APIURL+'/auth/login', obj).then(function(response) {
        return response.json();
      }).then(function(data) {
        console.log(data);
        if (data.login == true) {
          cb({
            authenticated: true,
            token: data.token,
            id: data.id
          })
        } else {
          cb({ authenticated: false })
        }    
      }).catch(function() {
        console.log("Fehler beim Usercheck");
      });
  }